import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './AsnOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class AsnOrders_copy_asn_order_udfs_to_new_order_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { sourceOrderId: number, targetOrderId: number }): Promise<void> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.sourceOrderId)) {
      missingRequiredInParams.push('\'sourceOrderId\'');
    }
    if (isNil(inParams.targetOrderId)) {
      missingRequiredInParams.push('\'targetOrderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/AsnOrders/functions/copy_asn_order_udfs_to_new_order_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

